import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from 'react-query';
import { resetPassword } from '../../mutations/mutations';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const PasswordChange = () => {
  const { user, isAuthenticated } = useAuth0();
  const [isLoading, setIsLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const createPasswordResetMutation = useMutation(resetPassword, {
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      setIsLoading(false);

      setSuccess(true);
    },
    onError: (error) => {
      setIsLoading(false);
      setSuccess(false);
    },
  });

  const changePassword = async () => {
    if (user?.email && isAuthenticated) {
      createPasswordResetMutation.mutate(user.email);
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h2">CHANGE PASSWORD</Typography>
      <Typography marginY={2} color={'grey'}>
        Resetting your password is easy. Just press the button below and follow
        the instruction.
      </Typography>

      {success && <Alert severity="success">Password Reset Email Sent</Alert>}

      {isLoading && (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}
        >
          <CircularProgress />
        </Box>
      )}

      <Button
        style={styles.button}
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
        onClick={changePassword}
      >
        Change Password
      </Button>
    </Container>
  );
};

export default PasswordChange;

const styles = {
  button: {
    marginTop: '20px',
  },
};
